"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_jss_1 = require("react-jss");
const react_router_dom_1 = require("react-router-dom");
const Button_1 = __importDefault(require("./components/Button"));
const Radiobutton_1 = __importDefault(require("./components/Radiobutton"));
const TextInput_1 = __importDefault(require("./components/TextInput"));
const ArrowBack_1 = __importDefault(require("./components/ArrowBack"));
const useStyles = (0, react_jss_1.createUseStyles)({
    root: {
        width: "100%",
        height: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        position: "relative",
    },
    wrapper: {
        display: "flex",
        flexDirection: "column",
        alignItems: "stretch",
        //justifyContent: center
        width: 500,
        maxWidth: "100%",
        margin: 0,
        padding: 20,
        background: "#ECECEC",
        borderRadius: 5,
        boxShadow: "0px 1px 2px #0006",
        "& > *": {
            margin: "20px 0",
        },
    },
    logo: {
        width: "100%",
    },
    form: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
    },
    input: {
        width: "80%",
        marginTop: 0,
    },
    button: {
        padding: "12px 60px",
    },
    radioGroup: {
        display: "flex",
        flexDirection: "row",
        gap: "20px",
        width: "80%",
        marginBottom: 20,
        "&:focus-within label": {
            // outline: "1px solid black",
            textDecoration: "underline",
        },
    },
    easy: {
        "&:has(> input:checked)": {
            background: "#86e2fdff",
        },
    },
    easyTriangle: {
        background: "#529cffff",
    },
    medium: {
        "&:has(> input:checked)": {
            background: "#9cfd7aff",
        },
    },
    mediumTriangle: {
        background: "#2bd12ed9",
    },
    hard: {
        "&:has(> input:checked)": {
            background: "#fca100ff",
        },
    },
    hardTriangle: {
        background: "#f76404ff",
    },
});
const SinglePlayerPage = () => {
    const [nickname, setNickname] = (0, react_1.useState)("");
    const classes = useStyles();
    const navigate = (0, react_router_dom_1.useNavigate)();
    const handleSubmit = (0, react_1.useCallback)(() => {
        navigate({
            pathname: "/game/",
            search: `?player=P1&nickname=${nickname}`,
        });
    }, [nickname]);
    const handleChange = (0, react_1.useCallback)((event) => {
        setNickname(event === null || event === void 0 ? void 0 : event.target.value);
    }, []);
    return (react_1.default.createElement("div", { className: classes.root },
        react_1.default.createElement(ArrowBack_1.default, null),
        react_1.default.createElement("div", { className: classes.wrapper },
            react_1.default.createElement("img", { src: require("!file-loader!../svg/logo.svg").default, className: classes.logo }),
            react_1.default.createElement("form", { className: classes.form, onSubmit: handleSubmit },
                react_1.default.createElement(TextInput_1.default, { className: classes.input, value: nickname, name: "nickname", label: "Nickname", error: null, onChange: handleChange, placeholder: "John Doe", autoFocus: true, required: true }),
                react_1.default.createElement("div", { className: classes.radioGroup },
                    react_1.default.createElement(Radiobutton_1.default, { className: classes.easy, classes: { triangle: classes.easyTriangle }, name: "difficulty", defaultChecked: true }, "Easy"),
                    react_1.default.createElement(Radiobutton_1.default, { className: classes.medium, classes: { triangle: classes.mediumTriangle }, name: "difficulty" }, "Medium"),
                    react_1.default.createElement(Radiobutton_1.default, { className: classes.hard, classes: { triangle: classes.hardTriangle }, name: "difficulty" }, "Hard")),
                react_1.default.createElement(Button_1.default, { className: classes.button }, "Play")))));
};
exports.default = SinglePlayerPage;
